// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Widget } from '@typeform/embed-react';
import parse from 'html-react-parser';

// Components
import Container from '../../container/container';

// Styles
import TypeformStyles from './typeform.styles';

export default function Typeform({ layout, isFirstLayout }) {
  const heading = layout?.heading;
  const text = layout?.text;
  const formId = layout?.formId;

  const bgColor = layout?.backgroundColour;

  return (
    <TypeformStyles bgColor={bgColor}>
      <Container>
        {heading &&
          (isFirstLayout ? (
            <h1 className="heading">{heading}</h1>
          ) : (
            <h2 className="heading large">{heading}</h2>
          ))}

        {text && <div className="text-wrapper">{parse(text)}</div>}

        <Widget id={formId} className="form" />
      </Container>
    </TypeformStyles>
  );
}

Typeform.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    text: PropTypes.string,
    formId: PropTypes.string,
    backgroundColour: PropTypes.string,
  }),
  isFirstLayout: PropTypes.bool,
};

Typeform.defaultProps = {
  layout: {},
  isFirstLayout: false,
};
